import type { PusherConstructor, PusherWindow } from '../../consts/pusher/sdk';

export function getPusherConstructor(): PusherConstructor | undefined {
  const pusherWindow = window as PusherWindow;
  return pusherWindow.Pusher;
}
